import React, { useState } from 'react';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add newsletter subscription logic here
    setEmail('');
  };

  return (
    <div className="bg-customBlue py-8 md:py-8 lg:py-8">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 3xl:px-16 max-w-7xl flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
        {/* Left section */}
        <div className="flex flex-col md:flex-row items-center text-center md:text-left gap-4">
          <svg 
            className="w-10 h-10 md:w-12 md:h-12 min-w-[40px] md:min-w-[48px] md:mr-5 fill-current text-blue-600"
            viewBox="0 0 24 24"
          >
            <path d="M21,5c-1.11-0.35-2.33-0.5-3.5-0.5c-1.95,0-4.05,0.4-5.5,1.5c-1.45-1.1-3.55-1.5-5.5-1.5S2.45,4.9,1,6v14.65 c0,0.25,0.25,0.5,0.5,0.5c0.1,0,0.15-0.05,0.25-0.05C3.1,20.45,5.05,20,6.5,20c1.95,0,4.05,0.4,5.5,1.5c1.35-0.85,3.8-1.5,5.5-1.5 c1.65,0,3.35,0.3,4.75,1.05c0.1,0.05,0.15,0.05,0.25,0.05c0.25,0,0.5-0.25,0.5-0.5V6C22.4,5.55,21.75,5.25,21,5z M21,18.5 c-1.1-0.35-2.3-0.5-3.5-0.5c-1.7,0-4.15,0.65-5.5,1.5V8c1.35-0.85,3.8-1.5,5.5-1.5c1.2,0,2.4,0.15,3.5,0.5V18.5z"/>
          </svg>
          <p className="font-nova-square text-gray-700 font-light text-sm md:text-base max-w-[200px] md:max-w-none">
            Newsletter — get updates with latest topics
          </p>
        </div>
        
        {/* Right section */}
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row w-full md:w-auto gap-2 sm:gap-0">
          <input 
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your e-mail address *" 
            className="flex-1 px-4 sm:px-6 md:px-8 lg:px-12 py-2 font-nova-square rounded sm:rounded-r-none bg-white/10 text-gray-700 placeholder-gray-400 border border-gray-400 focus:outline-none focus:border-blue-500 min-w-0 md:min-w-[300px]"
            required
          />
          <button 
            type="submit" 
            className="font-nova-square px-6 py-2 bg-blue-600 text-white rounded sm:rounded-l-none hover:bg-blue-700 transition-colors whitespace-nowrap"
          >
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewsletterSection;